var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BCard', {
    staticClass: "rounded-lg mb-0"
  }, [_c('Stack', {
    staticClass: "gap-2"
  }, [_c('h3', {
    staticClass: "mb-0 fw-700"
  }, [_vm._v(" " + _vm._s(_vm.$t('Flights Schedule')) + " ")]), _c('FlightsScheduleFilters', {
    attrs: {
      "departureFilter": _vm.departureFilter,
      "airportSupported": _vm.airportSupported,
      "departureDateFilter": _vm.departureDateFilter,
      "tripTypeFilter": _vm.tripTypeFilter,
      "stationTypeFilter": _vm.stationTypeFilter,
      "stationTypeSupported": _vm.stationTypeSupported,
      "departureHourFilter": _vm.departureHourFilter
    },
    on: {
      "update:departureFilter": function updateDepartureFilter($event) {
        _vm.departureFilter = $event;
      },
      "update:departure-filter": function updateDepartureFilter($event) {
        _vm.departureFilter = $event;
      },
      "update:departureDateFilter": function updateDepartureDateFilter($event) {
        _vm.departureDateFilter = $event;
      },
      "update:departure-date-filter": function updateDepartureDateFilter($event) {
        _vm.departureDateFilter = $event;
      },
      "update:tripTypeFilter": function updateTripTypeFilter($event) {
        _vm.tripTypeFilter = $event;
      },
      "update:trip-type-filter": function updateTripTypeFilter($event) {
        _vm.tripTypeFilter = $event;
      },
      "update:stationTypeFilter": function updateStationTypeFilter($event) {
        _vm.stationTypeFilter = $event;
      },
      "update:station-type-filter": function updateStationTypeFilter($event) {
        _vm.stationTypeFilter = $event;
      },
      "update:departureHourFilter": function updateDepartureHourFilter($event) {
        _vm.departureHourFilter = $event;
      },
      "update:departure-hour-filter": function updateDepartureHourFilter($event) {
        _vm.departureHourFilter = $event;
      }
    }
  }), _c('b-table', {
    ref: "tableRef",
    class: "position-relative ".concat(!_vm.isColoringTableFlightsSchedule ? 'custom-striped-table' : ''),
    style: _vm.maxHeightStyle,
    attrs: {
      "id": "flights-schedule-table",
      "sticky-header": "",
      "items": _vm.flightScheduleRender,
      "responsive": "",
      "show-empty": "",
      "empty-text": _vm.$t('noMatchingResult'),
      "no-border-collapse": "",
      "bordered": "",
      "striped": !_vm.isColoringTableFlightsSchedule,
      "small": !_vm.isColoringTableFlightsSchedule,
      "hover": "",
      "busy": _vm.loading,
      "fields": _vm.tableColumns,
      "head-row-variant": "green",
      "tbody-tr-class": function tbodyTrClass(item) {
        return _vm.resolveClassRow(item);
      }
    },
    on: {
      "row-clicked": _vm.onRowClicked
    },
    scopedSlots: _vm._u([_vm._l(_vm.tableColumns, function (column) {
      return {
        key: "head(".concat(column.key, ")"),
        fn: function fn(data) {
          return [_c('span', {
            key: column.key,
            staticClass: "text-nowrap text-center"
          }, [_c('div', [_vm._v(_vm._s(data.column === 'action' ? '' : _vm.$t("utils.flightsSchedule.columns.".concat(data.column).concat(['airportName', 'gate'].includes(data.column) ? _vm.tripTypeFilter : ''))))])])];
        }
      };
    }), {
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex-center text-dark my-2 gap-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        }), _c('strong', [_vm._v(_vm._s(_vm.$t('loading')))])], 1)];
      },
      proxy: true
    }, {
      key: "cell(scheduleTime)",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('Stack', {
          staticClass: "fw-600",
          attrs: {
            "center": ""
          }
        }, [_vm._v(" " + _vm._s(item.scheduleTime) + " ")])];
      }
    }, {
      key: "cell(estimateTime)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('Stack', {
          staticClass: "fw-600",
          attrs: {
            "center": ""
          }
        }, [_vm._v(" " + _vm._s(item.estimateTime) + " ")])];
      }
    }, {
      key: "cell(airportName)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('span', {
          staticClass: "fw-600"
        }, [_vm._v(" " + _vm._s(item.airportName) + " ")])];
      }
    }, {
      key: "cell(airlineName)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('HStack', {
          attrs: {
            "center": ""
          }
        }, [item.airline ? _c('IAmLogoAirline', {
          staticClass: "cursor-pointer",
          attrs: {
            "airline": item.airline,
            "longLogo": !_vm.isMobileView,
            "height": _vm.isColoringTableFlightsSchedule ? 40 : 30
          }
        }) : _vm._e(), !['VU', 'QH', 'VN', 'VJ', 'BL'].includes(item.airline) && !_vm.isMobileView ? _c('span', {
          staticClass: "fw-600"
        }, [_vm._v(" " + _vm._s(item.airlineName) + " ")]) : _vm._e()], 1)];
      }
    }, {
      key: "cell(flightNumber)",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('HStack', {
          attrs: {
            "center": ""
          }
        }, [item.airline && _vm.isMobileView ? _c('IAmLogoAirline', {
          staticClass: "cursor-pointer",
          attrs: {
            "airline": item.airline,
            "height": "16"
          }
        }) : _vm._e(), _c('div', {
          staticClass: "w-100 fw-600"
        }, [_vm._v(" " + _vm._s(item.flightNumber) + " ")])], 1)];
      }
    }, {
      key: "cell(gate)",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('span', {
          staticClass: "fw-600 d-flex-center"
        }, [_vm._v(" " + _vm._s(item.gate) + " ")])];
      }
    }, {
      key: "cell(terminal)",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c('span', {
          staticClass: "fw-600 d-flex-center"
        }, [_vm._v(" " + _vm._s(item.terminal) + " ")])];
      }
    }, {
      key: "cell(checkinRow)",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c('span', {
          staticClass: "fw-600 d-flex-center"
        }, [_vm._v(" " + _vm._s(item.checkinRow) + " ")])];
      }
    }, {
      key: "cell(remark)",
      fn: function fn(_ref9) {
        var _vm$resolveRemarkVari;
        var item = _ref9.item;
        return [item.remark ? _c('BBadge', {
          staticClass: "px-75",
          attrs: {
            "variant": ((_vm$resolveRemarkVari = _vm.resolveRemarkVariant) === null || _vm$resolveRemarkVari === void 0 ? void 0 : _vm$resolveRemarkVari[item.remark]) || 'light-secondary',
            "pill": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$te("utils.flightsSchedule.remark.".concat(item.remark)) ? _vm.$t("utils.flightsSchedule.remark.".concat(item.remark)) : item.remark) + " ")]) : _vm._e()];
      }
    }, {
      key: "cell(action)",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return [_c('BButton', {
          staticClass: "p-25 cursor-pointer rounded-circle",
          attrs: {
            "variant": "flat-dark"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.onRowClicked(item);
            }
          }
        }, [_c('IAmIcon', {
          class: "rotate-transition ".concat(item._showDetails ? 'rotate-180' : ''),
          attrs: {
            "icon": "chevronDownOutline"
          }
        })], 1)];
      }
    }, {
      key: "row-details",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [_vm.isMobileView ? _c('HStack', {
          staticClass: "gap-2"
        }, [_c('Stack', _vm._l(_vm.columnDetails, function (col) {
          return _c('div', {
            key: col,
            staticClass: "fw-500 text-nowrap"
          }, [_vm._v(" " + _vm._s(_vm.$t("utils.flightsSchedule.columns.".concat(col).concat(['airportName', 'gate'].includes(col) ? _vm.tripTypeFilter : ''))) + ": ")]);
        }), 0), _c('Stack', _vm._l(_vm.columnDetails, function (col) {
          return _c('div', {
            key: col,
            staticClass: "fw-600 text-nowrap"
          }, [col === 'airlineName' ? _c('div', [_vm._v(" " + _vm._s((item === null || item === void 0 ? void 0 : item[col]) || _vm.getAirlineNameByCode(item.airline)) + " ")]) : _c('div', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item[col]) + " ")])]);
        }), 0)], 1) : _vm._e()];
      }
    }], null, true)
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }